/**
 * BUBBLE-TEXT
 * Show text in bubble with arrow
 */

interface Props {
  text?: string
  children?: React.ReactNode
  orientation?: "left" | "right" | "top" | "bottom"
}

export default function BubbleText({ text, children, orientation = "left" }: Props) {
  return (
    <div className="relative inline-block -mt-10 ml-1">
      <div className="bg-white outline outline-[1px] outline-gray-500 font-bold px-5 py-4 rounded-xl relative z-0 text-center">
        {children ? children : `« ${text} »`}
      </div>

      {orientation === "left" && (
        <svg
          className="absolute left-0 top-1/2 -translate-x-full -translate-y-1/2 z-10"
          width="18"
          height="20"
          viewBox="0 0 18 20">
          <polygon points="0,10 18,3 18,17" fill="white" stroke="non" strokeWidth="1" />
          <path d="M0 10 L18 3 M0 10 L18 17" stroke="#6b7280" strokeWidth="1" fill="none" />
        </svg>
      )}

      {orientation === "right" && (
        <svg
          className="absolute right-0 top-1/2 translate-x-full -translate-y-1/2 z-10"
          width="18"
          height="20"
          viewBox="0 0 18 20">
          <polygon points="18,10 0,3 0,17" fill="white" stroke="#6b7280" strokeWidth="1" />
        </svg>
      )}
    </div>
  )
}
